export const ADMIN_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN_MANAGER: 'admin_manager',
};

export const canViewActualEarnings = adminRole =>
  adminRole === ADMIN_ROLES.SUPER_ADMIN;

export const canManageAdminTeam = adminRole =>
  adminRole === ADMIN_ROLES.SUPER_ADMIN;

export const canManagePayouts = adminRole =>
  adminRole === ADMIN_ROLES.SUPER_ADMIN;
